var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        "loading-spinner": "",
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("ItpDataTable", {
            attrs: {
              tableId: "MeterRelations",
              editable: "",
              value: _vm._.orderBy(_vm.items, ["created_at"], ["desc"]),
              rowTemplate: {
                meter_id: _vm.meter.id,
                inactive: false,
                factor: 0
              },
              columns: _vm.b_2248226175642056_columns
            },
            on: {
              save: function($event) {
                return _vm.evh_2248226175642056_save($event, {})
              },
              delete: function($event) {
                return _vm.evh_2248226175642056_delete($event, {})
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }